import { PageDoesntExist } from "@/pageDoesntExist";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { siteRoutes } from "../siteRoutesList";
import {
  TeamsOverviewFetcher,
  SingleTeamFetcher,
  CreateTeamForm,
} from "@/features/team";
import { SingleTeamSeeAllMembers } from "@/features/team/components/modals/SingleTeamSeeAllModalMembers";

export const teamRoutes = [
  // TEAMS
  {
    element: !brand.hasFeature.teams ? PageDoesntExist : TeamsOverviewFetcher,
    path: siteRoutes["teams"],
  },
  {
    element: !brand.hasFeature.teams ? PageDoesntExist : SingleTeamFetcher,
    path: `${siteRoutes["teamsAndSlug"]}:slug`,
  },
  {
    element: !brand.hasFeature.teams
      ? PageDoesntExist
      : () => CreateTeamForm({ isEdit: false }),
    path: siteRoutes["createTeam"],
  },

  {
    element: !brand.hasFeature.teams
      ? PageDoesntExist
      : SingleTeamSeeAllMembers,
    path: `${siteRoutes["teamsMembersAndSlug"]}:slug`,
  },
];
